export default __webpack_public_path__ + "static/media/back.1ae85297.svg";